import React, {Component} from "react";
import dateUtil from "date-and-time";
import {connect} from "react-redux";
import * as _ from "lodash";
import {NavLink} from "react-router-dom";
import Follow from "../../../commons/Follow";
import {setProjectDetails} from "../../../reducer/showAllReducer";
import {getCDNUrl,convertUnicode} from "../../../commons/CommonFunctions";

import ProjectDetails from "../commons/ProjectDetails";
import EntityFollow from "../../../commons/EntityFollow";
import {authService} from "../../../auth";
import { getCheckUserFollow } from "../../../services/FollowApi";

class RightPanel extends Component {
    state = {
        projectValue: {
            startDate: "",
            endDate: "",
            title: "",
            status: "",
            shortBrief: "",
            noOfParticipants: 0,
            noOfResearches: 0,
            feedbackCount: 0,
            companyName: "",
            location: {},
            creatorUserId: "",
            followed:false,
            imageUrl:'',
            creatorBannerImage:'',
            customUrl:'',
            partyType: '',
            params : []
        },
        userData: authService.getUserDetailsFromLocalStorage(),
        userFollowed: false
    };
    redirectToProfile = (customUrl, partyType) => {
        if(partyType === "CIRCLE"){
            window.location.href = "/community/" + customUrl;
        }else {
            window.location.href = "/profile/" + customUrl;
        }
    }

    setProjectDetails = function (projectDetails) {
        window.$('#projectDetails').modal('show');
        this.props.setProjectDetails(projectDetails);
    }

    componentDidMount() {
        if (this.props.projectDetail && this.props.projectDetail.isApproved != undefined) {
            this.setProjectValue(this.props);
            if(!this.props.projectDetail?.followed && this.props.userId) {
                this.checkFollowedData();
            }
        }
    }

    componentWillReceiveProps(props) {
        if (props.projectDetail && props.projectDetail.isApproved != undefined) {
            this.setProjectValue(props);
        }
    }

    setProjectValue = (props) => {
        let participationDetails = props.projectDetail.participationDetails;
        let project = props.projectDetail.project;
        let startDate = "";
        let endDate = "NA";
        let creatorBannerImage = this.props.projectDetail.creatorBannerImage;
        let resizedCreatorBannerImages = this.props.projectDetail.resizedCreatorBannerImages;
        let customUrl = this.props.projectDetail.customUrl;
        let partyType = this.props.projectDetail.partyType;
        let params = this.props.projectDetail.params;
        let userDeactivated = this.props.projectDetail.deactivated;
        let stageValue = "Completed";
        let imageUrl=props.projectDetail.imageUrl;

        let proj = props.projectDetail.project;
        let title = proj.title;
        let stage = props.projectDetail.stage;

        startDate = dateUtil.format(
            new Date(props.projectDetail.startDate),
            "DD MMM YYYY"
        );
        if(project.endingTime >0){
            endDate = dateUtil.format(new Date(project.endingTime), "DD MMM YYYY");
        }
        /*stageValue = "Running";

        if (new Date() < new Date(props.project.startDate)) {
            stageValue = "UpComing";
        } else if (new Date() > new Date(props.project.endDate)) {
            stageValue = "Completed";
        }*/
        stageValue = stage.charAt(0).toUpperCase() + stage.slice(1);

        let participationCount = participationDetails.participationCount;
        let noOfParticipant = participationDetails.noOfParticipant;
        let shortBrief = project.shortBrief;
        let creatorUserId = project.userId;
        let followed = props.projectDetail.followed;
        let location = project.location;
        let postedBy = participationDetails.postedBy;

        this.setState({
            projectValue: {
                ...this.state.projectValue,
                startDate,
                endDate,
                title,
                status: stageValue,
                noOfParticipants: noOfParticipant || participationCount,
                shortBrief,
                location,
                creatorUserId,
                followed,
                companyName: postedBy,
                imageUrl,
                creatorBannerImage,
                resizedCreatorBannerImages,
                customUrl,
                partyType,
                params,
                userDeactivated
            },
        });
    };

    getNoOfResearches = () => {
        let researchDiv = (
            <li>
                <i className="iAddResearch_fl"></i>
                {this.state.projectValue.noOfResearches} Researches
            </li>
        );

        if (
            this.state.projectValue.noOfResearches &&
            this.state.projectValue.noOfResearches > 0
        ) {
            return researchDiv;
        } else {
            return undefined;
        }
    };

    getFeedback = () => {
        let feedbackDiv = (
            <div className="projdtlsfeedsrating">
                <i className="iStar staractive"></i>
                <i className="iStar staractive"></i>
                <i className="iStar staractive"></i>
                <i className="iStar staractive"></i>
                <i className="iStar"></i>
                <span>{this.state.projectValue.feedbackCount} Feedbacks</span>
            </div>
        );

        if (
            this.state.projectValue.feedbackCount &&
            this.state.projectValue.feedbackCount > 0
        ) {
            return feedbackDiv;
        } else {
            return undefined;
        }
    };

    getOptimizedCreatorImage(projectValue) {
        if (window.innerWidth > 1000 && projectValue.resizedCreatorBannerImages && projectValue.resizedCreatorBannerImages['400x400'] != null) {
            return projectValue.resizedCreatorBannerImages['400x400'];
        } else if (projectValue.resizedCreatorBannerImages && projectValue.resizedCreatorBannerImages['compressed'] != null) {
            return projectValue.resizedCreatorBannerImages['compressed'];
        } else {
            return projectValue.creatorBannerImage;
        }
    }

    checkFollowedData = async () => {
        let response = await getCheckUserFollow({userId: this.state.userData.userId, otherUserId: this.props.userId});
        if(response?.message === "Success!") {
            this.setState({
                userFollowed: response.body?.result
            })
        }
    }

    render() {
        const { isDonationData } = this.props;
        const { userFollowed, projectValue } = this.state;
        return (
            <div className="col-lg-3 projDtlsRTpanel">
                <div className="projdtlsfeedswidget">
                    <div className="imgbox" onClick={(e) => {
                        e.preventDefault();
                        this.redirectToProfile(projectValue.customUrl,  projectValue.partyType)
                    }} style={{cursor:'pointer'}}>
                        <img src={projectValue && projectValue.creatorBannerImage ? getCDNUrl(this.getOptimizedCreatorImage(projectValue)):(!_.isUndefined(projectValue.creatorBannerImage)) ? 'https://cdn.dscovr.com/images/prof-banner.png' : null} alt=""/>
                    </div>

                    <h3>Posted by</h3>
                    <div className="companyname">
                        <div  className= {"projhead" + ((projectValue.partyType === "COMPANIES" || projectValue.partyType === "BUSINESS_PAGES") ? " orgnzName" : "")}>
                            <figure className="complogo" onClick={(e) => {
                                e.preventDefault();
                                this.redirectToProfile(projectValue.customUrl , projectValue.partyType)
                            }} style={{cursor:'pointer'}}>
                                <img src={projectValue && projectValue.imageUrl ? getCDNUrl(projectValue.imageUrl):(projectValue.partyType == "CIRCLE" ? "https://cdn.dscovr.com/images/circleDefault.webp" :  this.props.projectDetail.userType == "INDIVIDUAL" ? "https://cdn.dscovr.com/images/users1.png" : "https://cdn.dscovr.com/images/DefaultBusiness.png")} onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/circleDefault.png"}}  alt=""/>
                            </figure>
                            <div>
                              <a onClick={(e) => {
                                                   e.preventDefault();
                                                    this.redirectToProfile(projectValue.customUrl, projectValue.partyType)
                                                }} >
                                <h5>{projectValue && projectValue.companyName}</h5></a>
                                {(projectValue && projectValue.creatorUserId && projectValue.partyType!= "CIRCLE" && !projectValue.userDeactivated) ?
                                <Follow userId={projectValue && projectValue.creatorUserId} followed={(projectValue && projectValue.followed)|| userFollowed}/>  :
                                    /*projectValue && projectValue.params &&
                                <EntityFollow entityType={'CIRCLE'} entityId={projectValue.params && projectValue.params['circleId'] } followed={projectValue.followed}
                                userId={this.state.userData.userId} isCircle={true}/>*/ null
                                }
                                {projectValue && projectValue.location && projectValue.location.city &&
                                <span className="address">
                                  {projectValue.location.city +
                                  ", " +
                                  projectValue.location.state +
                                  ", " +
                                  projectValue.location.country}
                                </span>
                                }
                            </div>
                        </div>
                    </div>

                </div>

                <div className="projdtlsfeedswidget">
                    {!isDonationData ? 
                        <>
                            <div className="projdtlsfeedswidgetdesc">
                                {/*<ProjectDetails projectType={this.props.project && this.props.project.participationDetails && this.props.project.participationDetails.secondaryEntityType}/>*/}
                                <h4><a href="javascript:void(0)"
                                    onClick={(e) => this.setProjectDetails(this.props.projectDetail)}
                                    //data-toggle="modal"
                                >
                                    {convertUnicode(projectValue && projectValue.title && projectValue.title)}
                                </a>
                                </h4>
                                <p>{projectValue && projectValue.shortBrief.split("\\n").map(brief => (<>{convertUnicode(brief)}<br/></>))}</p>
                            </div>
                            <ul>
                                {projectValue && projectValue.noOfParticipants &&
                                projectValue.noOfParticipants > 0 && (
                                    (this.props.projectDetail && this.props.projectDetail.participationDetails && this.props.projectDetail.participationDetails.secondaryEntityType && this.props.projectDetail.participationDetails.secondaryEntityType === 'FUNDRAISE')?
                                    <li>
                                        <i className="iParticipants"></i>{" "}
                                        {projectValue.noOfParticipants} {projectValue.noOfParticipants <2 ? "Contributor" : "Contributors"}
                                    </li>:
                                    <li>
                                        <i className="iParticipants"></i>{" "}
                                        {projectValue.noOfParticipants} {projectValue.noOfParticipants <2 ? "Applicant" : "Applicants"}
                                    </li>

                                )}
                                {this.getNoOfResearches()}
                            </ul>
                        </>  : null
                    }
                    {this.getFeedback()}

                    {/* <div className="pdfeedsdate">
                        <div>
                            Start Date
                            <span>{projectValue && projectValue.startDate}</span>
                        </div>
                        <div>
                            End Date
                            <span>{projectValue && projectValue.endDate}</span>
                        </div>
                    </div>
                    <div className="pdfeedssstaatus">
                        {projectValue && projectValue.status}
                    </div> */}
                </div>
                {!isDonationData &&
                <>
                    <div className="projdtlsfeedswidgetbott links">
                        <NavLink exact to="/PrivacyPolicy">Privacy Policy</NavLink> <span>|</span>
                        <NavLink exact to="/TermsConditions">Terms & Conditions</NavLink> <span>|</span>
                        {/*<NavLink exact to="/UserAgreement">User Agreement</NavLink>*/}
                        <NavLink exact to="/CookiePolicy" >Cookie Policy</NavLink>
                    </div>

                    <div className="projdtlsfeedswidgetbott">
                        All Rights Reserved. <br/>
                        2019 © Dscovr Journeys
                    </div>
                </>}
                <ProjectDetails projectType={projectValue.type}/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        project: state.showAllReducer.projectDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setProjectDetails: (projectDetails) =>
            dispatch(setProjectDetails(projectDetails)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RightPanel);
